import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Mark Stone', 
        title: 'Garden Expert',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero voluptate omnis hic? Omnis repudiandae aliquid iure beatae distinctio temporibus quia expedita earum aliquam consequuntur. Tempora totam eum quos veniam illo.',
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Lisa Green', 
        title: 'Landscape Specialist',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero voluptate omnis hic? Omnis repudiandae aliquid iure beatae distinctio temporibus quia expedita earum aliquam consequuntur. Tempora totam eum quos veniam illo.',
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'George Hill', 
        title: 'Garden Consultant',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero voluptate omnis hic? Omnis repudiandae aliquid iure beatae distinctio temporibus quia expedita earum aliquam consequuntur. Tempora totam eum quos veniam illo.',
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Mia Reed', 
        title: 'Garden Consultant',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero voluptate omnis hic? Omnis repudiandae aliquid iure beatae distinctio temporibus quia expedita earum aliquam consequuntur. Tempora totam eum quos veniam illo.',
    },
];

export default testimonials;